export enum MigratedClientEnum {
    ALL_CLIENTS = 'Todos',
    HAS_FINANCIAL = 'Migrados',
    NOT_HAS_FINANCIAL = 'Não migrados',
}

export type MigratedClient = 'ALL_CLIENTS' | 'HAS_FINANCIAL' | 'NOT_HAS_FINANCIAL';
